<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <table class="table">
          <table-row label="Role"  :noBorder="true">
            {{ role.role }}
          </table-row>

          <table-row label="Permissions">
            <span v-for="item in role.permissions" :key="item.id">
              - {{ item.permission }}
              <br />
            </span>
          </table-row>
          <table-row icon="lni-database" :noBorder="true" />

          <table-row label="Id">
            {{ role.id }}
          </table-row>

          <table-row label="Created">
            {{
              moment(new Date(role.created_at)).format("DD MMM YYYY, HH:mm:ss")
            }}
          </table-row>
          <table-row label="Updated">
            {{
              moment(new Date(role.updated_at)).format("DD MMM YYYY, HH:mm:ss")
            }}
          </table-row>
        </table>

      </b-col>
    </b-row>
  </div>
</template>

<script>
import roleRepo from "@/api/repos/roleRepo";
import tableRow from "@/components/common/TableRow"

export default {
  props: ["id"],

  components:{
    tableRow
  },

  mounted() {
    this.getRole();
  },

  data() {
    return {
      loading: false,
      role: {
        role: "",
        permissions: [],
      },
    };
  },

  methods: {
    async getRole() {
      try {
        this.loading = true;
        let { data } = await roleRepo.get(this.id);
        this.role = data.role;
        this.role.permissions = data.role.permissions;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
